import React from 'react';
import { connect } from 'react-redux';
import backToSignIn from './ResetPasswordActions';
import ForgotYourPasswordForm from './ForgotYourPasswordForm';
import { FORGOT_YOUR_PASSWORD, CHECK_YOUR_IN_BOX } from '../reset-password/ResetPasswordConstants';
import CheckYourInBoxContainer from '../reset-password/CheckYourInBoxContainer';
import ResetPasswordApi from '../api/ResetPasswordApi';

class ForgotYourPasswordContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: FORGOT_YOUR_PASSWORD,
      instructions: {
        text: 'Enter your email and we\'ll send you instructions to reset your password.',
      },
      errorMessage: '',
    };
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(values) {
    ResetPasswordApi.submitPasswordReset(values.email).then(() => {
      this.setState({
        step: CHECK_YOUR_IN_BOX,
      });
    }).catch((error) => {
      console.log('submitPasswordReset-error', error); // eslint-disable-line no-console
      if (error.response.status === 404) {
        this.setState({
          errorMessage: 'Email not found: Sorry, we don\'t recognize that email. Please try again.',
        });
      } else if (error.response.status === 400 || error.response.status === 406) {
        this.setState({
          errorMessage: 'Unexpected error occurred. Please try again.',
        });
      } else {
        this.setState({
          errorMessage: 'Unexpected error occurred. Please try again later.',
        });
      }
    });
  }

  render() {
    if (this.state.step === FORGOT_YOUR_PASSWORD) {
      return (
        <ForgotYourPasswordForm
          {...this.props}
          onSubmit={this.onSubmit}
          instructions={this.state.instructions}
          errorMessage={this.state.errorMessage}
        />
      );
    }
    return (
      <CheckYourInBoxContainer />
    );
  }
}

const mapDispatchToProps = dispatch => ({
  onBackToSignIn: () => dispatch(backToSignIn()),
});

const mapStateToProps = (_, ownProps) => ({
  initialValues: {
    email: ownProps.defaultCustomerEmail,
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotYourPasswordContainer);
